import React from "react";
import logo from "../assets/registerImages/pmk-logo.svg";
import { withTranslation } from "react-i18next";
import "react-confirm-alert/src/react-confirm-alert.css";
import { confirmAlert } from "react-confirm-alert";
import { Slide, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Dropdown } from "react-bootstrap";
import RingLoader from "react-spinners/ClipLoader";
import { connect } from "react-redux";

import { setEnvironment } from "../../common/actions/userAccount/userAccountAction";

import appStoreIcon from "../assets/commonImages/appStoreIcon.png";
import googlePlayIcon from "../assets/commonImages/googlePlayIcon.png";

const select_server = [
  { key: 0, section: true, label: "Set Environment", value: 0 },
  { key: 1, label: "Staging", value: 1 },
  { key: 2, label: "Develop", value: 2 },
  { key: 3, label: "Live", value: 3 },
  { key: 3, label: "localhost", value: 4 },
];
class RegisterHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      env: "prod",
      clickCount: 0,
      isShowModal: false,
      //selectedServerKey: 0,
    };
   
  }

  getServerNameByKey = (value) => {
    
    for (let i = 0; i < select_server.length; i++) {
      if (parseInt(value) === parseInt(select_server[i].value)) {
        console.log("select_server[i]", select_server[i].label);
        return select_server[i].label;
      }
    }
  };

  setServerEnvironment = () => {
    const { doSetEnvironment } = this.props;
    let selectedServerKey = 0;
    //this.setState({ isShowModal: true });
    console.log("selected server key", selectedServerKey);
    console.log("selected server", select_server);

    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui">
            <div className="react-confirm-alert">
              <div className="react-confirm-alert-body">
                <h1 className="mb-40">{this.props.t("select_server_text")}</h1>
                <div className="form-group">
                  <Dropdown
                    className="custom-dropdown"
                    onSelect={(eventKey) => {
                      selectedServerKey = eventKey;
                      this.setState(
                        {
                          clickCount: 0,
                          //isShowModal: false
                        },
                        () => {
                          doSetEnvironment({
                            env: this.getServerNameByKey(
                              selectedServerKey
                            ).toLowerCase(),
                          });
                          //onClose();
                        }
                      );
                      onClose();
                    }}
                  >
                    <Dropdown.Toggle>
                      {this.getServerNameByKey(selectedServerKey)}
                      {select_server.length === 0 && (
                        <RingLoader color="#2d3d56" loading={true} size={20} />
                      )}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      {select_server.map((data) => {
                        return (
                          <Dropdown.Item
                            className={
                              parseInt(selectedServerKey) ===
                              parseInt(data.value)
                                ? "active"
                                : ""
                            }
                            eventKey={data.value}
                            key={data.key}
                          >
                            <span className="dropdownitem-label">
                              {data.label}
                            </span>
                          </Dropdown.Item>
                        );
                      })}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
          </div>
        );
      },
    });
  };

  render() {
    const { clickCount, isShowModal } = this.state;
    
    return (
      <div className="col-sm-12 col-md-7 col-lg-7 col-xl-8 main-col">
        <div className="pmk-landing">
          <div className="logo-wrapper">
            <a
              className="navbar-brand"
              //href="/"
              onClick={() => {
                // let { clickCount } = this.state;
                // this.setState({ clickCount: ++clickCount });
                // if (clickCount >= 3) {
                //   //this.setState({isShowModal: true})
                //   this.setServerEnvironment();
                // }
              }}
            >
              <img src={logo} alt="PikMyKid" title="PikMyKid" />
            </a>
          </div>

          <div className="welcome-sect">
            <div className="title-sect">
              <h1 className="title-1">
                {this.props.t("landingScreen-welcome-to")} Pikmykid!
              </h1>
            </div>
          </div>
          <div className="appdownload-sect">
            <div className="appdownload-wrapper">
              <p>{this.props.t("download_message")}</p>
              <div className="appdownload-icons">
                <a
                  className="store-icon google-play"
                  href="https://play.google.com/store/apps/details?id=com.pikmykid.parentapp&hl=en_IN&gl=US"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={googlePlayIcon}
                    alt="Google play"
                    title="Google play"
                  />
                </a>
                <a
                  className="store-icon appstore"
                  href="https://apps.apple.com/us/app/pikmykid-parent/id1559538995"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={appStoreIcon} alt="App Store" title="App Store" />
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* {isShowModal && this.setServerEnvironment()} */}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    environment: state.userAccount.environment,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    doSetEnvironment: (data) => dispatch(setEnvironment(data)),
  };
}
export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(RegisterHeader)
);
